export default "__VITE_ASSET__Capor4Fi__"